import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { TuiLanguageSwitcherService } from '@taiga-ui/i18n';
import { EMPTY, tap } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { mapLanguageToTui, saveLanguageToStorage } from '@common/utils/lang';
import { UsersService } from '@services/users.service';
import { WebsocketService } from '@services/websocket.service';
import { getCurrentUser, storeCurrentUser } from '@store/actions/current_user.actions';

@Injectable()
export class CurrentUserEffects {
  private readonly switcher = inject(TuiLanguageSwitcherService);
  private readonly translate = inject(TranslateService);
  private readonly actions$ = inject(Actions);
  private readonly usersService = inject(UsersService);
  private readonly websocketService = inject(WebsocketService);

  getCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCurrentUser),
      exhaustMap(() =>
        this.usersService.getCurrentUser().pipe(
          tap((user: any) => {
            this.translate.use(user.language);
            this.switcher.setLanguage(mapLanguageToTui(user.language));
            saveLanguageToStorage(user.language);

            sessionStorage.setItem(
              'timezone',
              `UTC${user.timezone >= 0 ? '+' : ''}${user.timezone}`,
            );
          }),
          map((currentUser: any) => {
            this.websocketService.connectUserSocket(currentUser);
            return storeCurrentUser({ currentUser });
          }),
          catchError(() => EMPTY),
        ),
      ),
    ),
  );
}
